// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CategoryDetail--next-sr-only--3IpJLZL","field":"CategoryDetail--field--1ItUXrg","errorContent":"CategoryDetail--errorContent--1ASqIvz"};